module.exports = __webpack_public_path__ + "static/media/kapil-pic.964fb3ab.jpg";